import React from 'react';
import { AdCampaignStatus } from '@/types/ads';

const statusConfig: Record<AdCampaignStatus, { bg: string; label: string }> = {
  DRAFT: { bg: 'bg-gray-600', label: 'Borrador' },
  ACTIVE: { bg: 'bg-green-600', label: 'Activo' },
  PAUSED: { bg: 'bg-yellow-500', label: 'Pausado' },
  ARCHIVED: { bg: 'bg-red-700', label: 'Archivado' },
};

const AdCampaignStatusBadge: React.FC<{ status: AdCampaignStatus }> = ({ status }) => {
  const config = statusConfig[status];
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs ${config.bg} text-white font-bold justify-center`}>
      {config.label}
    </span>
  );
};

export default AdCampaignStatusBadge;

